import React from 'react';
import { GRIP_LABELS, nextGrip } from './api';

// Cycles Pull-up -> Chin-up -> Neutral. Fixed min-width so the row does not
// shift as the label length changes between taps.
export const GripPill = ({ grip, onChange, testid }) => (
  <button
    type="button"
    onClick={() => onChange(nextGrip(grip))}
    aria-label={`Grip: ${GRIP_LABELS[grip]}. Tap to change.`}
    className="shrink-0 min-w-[6rem] text-center border border-mono-line text-mono-mute hover:border-white hover:text-white font-heading text-[11px] font-bold uppercase tracking-[0.15em] rounded-full px-3.5 py-2.5 transition-colors active:scale-95"
    data-testid={testid}
  >
    {GRIP_LABELS[grip]}
  </button>
);

export default GripPill;
